import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  fakeArray = new Array(12);
  selectedId=0;
  constructor(public dialogRef: MatDialogRef<TimePickerComponent>) { }

  ngOnInit(): void {
  }

  isSelected(index:number):boolean{
    if(this.selectedId==index){
      return true;
    }
    else{
      return false;
    }
  }
  selectButton(index:number){
    this.selectedId=index;
  }
  Save(){
  this.dialogRef.close((this.selectedId+1)*5);
  }
}
